import { render, staticRenderFns } from "./HeartMedicalDetails.vue?vue&type=template&id=47fa6f8e"
import script from "./HeartMedicalDetails.vue?vue&type=script&lang=js"
export * from "./HeartMedicalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports